let Values = {
  HARD  : 'HARD',
  SOFT  : 'SOFT',
  CUSTOM: 'CUSTOM',
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value, custom) => {
    switch (value) {

      case Values.HARD:
        return "Dur";

      case Values.SOFT:
        return "Mou";

      case Values.CUSTOM:
        return custom;

      default:
        return value;
    }
  },

  /* Get short for value. */
  short: (value, custom) => {
    switch (value) {

      case Values.HARD:
        return "Dur";

      case Values.SOFT:
        return "Mou";

      case Values.CUSTOM:
        return custom;

      default:
        return value;
    }
  }
});
